import Fetch from "@/utils/Fetch"
import filtersToSearchParams from "@/utils/filtersToSearchParams";

export default {
	namespaced: true,
	state() {
		return {
			supplierList: [],
            supplierBlocks: {
                newUsersCount: null,
                newUsersList: null,
                tenderParticipantsCount: null,
                tenderParticipantsList: null,
                tendersCount: null,
                tendersList: null,
                commercialOffersCount: null,
                commercialOffersList: null
            },
            filter: {
                order: null,
                dateFrom: null,
                dateTo: null
            },
            pagination: {
                total: 0,
                offset: 0,
                limit: 10,
            },
            supplierOffers: [],
            supplierBlock: []
		}
	},
	mutations: {
        setSupplierList(state, value) {
            state.supplierList = value
        },
        setPagination(state, paginationData) {
            if (!paginationData) return;
            Object.assign(state.pagination, {...paginationData})
        },        
        setFilter(state, filterData) {
            if (!filterData) return;
            Object.assign(state.filter, {...filterData})
        },
        
        setSuppliersBlocks(state, {key, value}) {
            state.supplierBlocks[key] = value
        },
        setSupplierOffers(state, value) {
            state.supplierOffers = value
        },
        setSupplierBlock(state, value) {
            state.supplierBlock = value
        }
	},
	actions: {  
        async requestStatistics({commit, dispatch, state}) {
            commit('startLoading', 'requestStatistics', {root: true})

            const {offset, limit} = state.pagination;
            const search = filtersToSearchParams(state.filter, offset, limit);

            const response = await Fetch(`tenders/stats/${search}`, {})
            if (response.success) {
                commit('setSupplierList', response.data?.suppliersRating.items)
                commit('setPagination', {total: Number(response.data?.suppliersRating.countTotal)})

                for (const key in response.data) {
                   if(key !== 'suppliersRating') {
                       commit('setSuppliersBlocks', {key, value: response.data[key]})
                   }
                }

            } else {
                dispatch('showError', response.message, {root: true})
            }

            commit('stopLoading', 'requestStatistics', {root: true})

            return {
                ...response.data
            }
        },
               
        updatePagination({commit, dispatch}, paginationData) {
            commit('setPagination', paginationData);
            dispatch('requestStatistics', false);
        },

        updateFilter({commit, dispatch}, filterData) {
            commit('setFilter', filterData);
            commit('setPagination', {offset: 0});
            dispatch('requestStatistics', false);
        },

        async requestSupplierOffers({commit, dispatch}, supplierData) {
            commit('startLoading', 'requestSupplierOffers', {root: true})
           
            const searchQuery = filtersToSearchParams({productName: supplierData.search.productName, tenderName: supplierData.search.tenderName}, supplierData.search.offset, supplierData.search.limit);
    
            const response = await Fetch(`tenders/stats/supplier-offers/${supplierData.id}/${searchQuery}`, {})
            if (response.success) {
                commit('setSupplierOffers', response.data)
            } else {
                dispatch('showError', response.message, {root: true})
            }

            commit('stopLoading', 'requestSupplierOffers', {root: true})

            return {
                ...response.data
            }
        },

        async requestBlock({commit, dispatch, state}, blockData) {
            commit('startLoading', 'requestBlock', {root: true})
            const searchQuery = filtersToSearchParams({dateTo: state.filter.dateTo , dateFrom: state.filter.dateFrom}, blockData.search.offset, blockData.search.limit);
    
            const response = await Fetch(`tenders/stats/${blockData.key}/${searchQuery}`, {})
            if (response.success) {
                commit('setSupplierBlock', response.data)
            } else {
                dispatch('showError', response.message, {root: true})
            }

            commit('stopLoading', 'requestBlock', {root: true})

            return {
                ...response.data
            }
        },

	},

	getters: {
		getSupplierBlocks: state => state.supplierBlocks,
        getSupplierList: state => state.supplierList,
        getSupplierPagination: state => state.pagination,
        getSupplierFilter: state => state.filter,
        getSupplierOffers: state => state.supplierOffers,
        getSupplierBlock: state => state.supplierBlock
	}
}

